// extracted by mini-css-extract-plugin
export default {"links":"CarryForward_links__sFpZJ"};